export { default } from './CMSPartialTemplate';
